export default {
    SIMPLEAUTH: { name: 'SIMPLEAUTH', module: 'SIMPLEAUTH' },
    STCA_INGET: { name: 'STCA_INGET', module: 'STCA_INGET' }
};